import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './pdfYousign.html?raw';
import lang from 'dojo/_base/lang';
import _WidgetBaseSP from 'more/_WidgetBaseSP';

import pdfEditor from '../pdfEditor/pdfEditor';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';

import * as pdfTypes from "./../../fileViewer/pdfViewer/pdfTypes";

class pdfYousign extends compose(_WidgetBaseSP) {
    templateString: any = template;
    private disabled_mobile_syncfusion_editor = true;
    public max_signers_per_object = 4; // <- wird vom server ueberschrieben bei data request
    private available_signers = 4; //wie viele sig felder max. gesetzt werden duerfen
    private max_values_singfield: any = {
        height:{
            min:37,
            max:1000
        },
        width:{
            min:85,
            max:2000
        }
    }; // https://developers.yousign.com/docs/fields-creation-new#signature-field-1

    private pdfEditor: MdsLax<InstanceType<typeof pdfEditor>>;
    private ysContainer: HTMLDivElement;
    private mobileMsgContainer:HTMLDivElement;
    public dlg: MdsLax<InstanceType<typeof GenericDialog>>
    private yousignFields: Record<number, { id?: string, fallbackID?: string, field: pdfTypes.yousignField, name?: string, isReadonly?: boolean, fieldID?: number, type?: "signature" | "mention" }> = {};

    private flagBlockDeleteEvent: boolean = false;

    private saveDebounce_delay: number = 2000; //ms
    private saveDebounce: number;//timeout

    private saveIconContainer:HTMLSpanElement; //wird NICHT von dojo gesetzt...
    private pitID:string;

    private flagIsMobileSyncfusionPdfViewer = false;

    private isDirty = false;

    private flagIsUsingDlg = false;

    private availableFields: Record<number, { displayName?: string, currentSignaturePlacement?: string, fieldID?: number, type?: "mention" | "signature", readonly?: boolean }> = [];
    private usedFieldsCounter: number = 0;

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.pdfEditor = new pdfEditor();
        this.pdfEditor.placeAt(this.ysContainer);
        this.pdfEditor.on("yousignFieldAdded", lang.hitch(this, this._on_YousignFieldAdded));
        this.pdfEditor.on("formFieldMove", lang.hitch(this, this._onPdfViewer_FieldMove));
        this.pdfEditor.on("formFieldResize", lang.hitch(this, this._onPdfViewer_FieldResize));
        this.pdfEditor.on("formFieldRemove", lang.hitch(this, this._onPdfViewer_FieldRemoved));
        this.pdfEditor.on("yousignMobileModeDetected", lang.hitch(this, ()=>{
            this.flagIsMobileSyncfusionPdfViewer = true;
            if (this.disabled_mobile_syncfusion_editor == true){
                return;
            }
            this.mobileMsgContainer.innerHTML = '<i class="far fa-dizzy w3-xlarge w3-padding-right"></i><span class="w3-xlarge">' + this.translate("pdfYousign__mobile_not_available") + '</span>';
            this.ysContainer.classList.add("w3-hide");
        }));

        window.addEventListener("beforeunload", lang.hitch(this, (ev) => {
            if ((this.isDirty) && (this.flagDisableAutoSave == false)) {
                if (this._destroyed != true){ //weil ansonsten bei onError evtl. der tab close blockiert wird lange nach diesem widget
                    this.showToast(this.translate("pdfYousign__Unsaved"));
                    ev.preventDefault();
                    return '';
                }
            }
        }));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    private yF_getFreeIndex() {
        let i = 1;
        while (i in this.yousignFields) {
            i++;
        }
        return i;
    }

    private availableFields_getFreeIndex() {
        let i = 0;
        while (i in this.availableFields) {
            i++;
        }
        return i;
    }

    private yF_length() {
        return Object.keys(this.yousignFields).length;
    }

    private showPdf(key: FileFinder.DescriptorRequestData, showAsDlg: boolean) {
        this.pdfEditor.overwrite_config = lang.hitch(this, this.pdfConfig_overload);
        this.pdfEditor.show(key, false);
        if (showAsDlg) {
            this.dlg = new GenericDialog();
            this.dlg.destroyOnClose = true;
            this.dlg.closeOnEnter = false;
            this.dlg.closeOnEscape = false;
            this.dlg.setSize('larger');
            this.dlg.show(this, this.translate("pdfYousign__header"), null, null, 'close');
            this.dlg._setTopCloseBtnAttr(false);
            this.dlg.show(this);
            this.flagIsUsingDlg = true;
            this.dlg.on("closed", (param: any) => {
                this.save();
                this.emit("closed", param)
            });
            this.dlg.emit("opened", true);
        }
    }

    private pdfConfig_overload(config: pdfTypes.PdfViewerConfig) {
        config.ToolbarConfig.YouSignSignature = true;

        config.ToolbarConfig.AnnotationEditTool = false;
        config.ToolbarConfig.CommentTool = false;
        config.ToolbarConfig.SaveButton = false;
        config.ToolbarConfig.SelectionTool = false;
        config.ToolbarConfig.PanTool = false; //ui bug mit sig place...
        config.pageOrganizerSettings.enablePageOrganizer = false;
        config.enableRightClickMenu = false;
        config.cancelDownloads = true;
        config.ToolbarConfig.FormDesignerEditTool = true;
        return config;
    }

    private _on_YousignFieldAdded(field: pdfTypes.yousignField) {
        debugger;
        let freeIndex = this.yF_getFreeIndex();
        let fieldConfig = this.availableFields[this.usedFieldsCounter];
        this.yousignFields[freeIndex] = { field: field, fieldID: fieldConfig.fieldID, name: fieldConfig.displayName, type: fieldConfig.type };
        this.usedFieldsCounter++;

        if ((this.usedFieldsCounter == this.available_signers) || (this.usedFieldsCounter > this.available_signers)) {
            this.pdfEditor.getPdfViewerWidget().yousign_addSigBtn_disabled(true);
        } else {
            this.pdfEditor.getPdfViewerWidget().yousign_addSigBtn_disabled(false);
        }
        this.render_fields();
        this.debounceSave();
    }

    private render_fields() {
        this.flagBlockDeleteEvent = true;
        let viewerWidget = this.pdfEditor.getPdfViewerWidget();
        let viewer = viewerWidget.getSyncFusionPdfViewer();

        //cleanup wir loeschen alle formfields da diese verbuggt sind
        let ids = {}; //weil keine js Sets...
        let foreign_element = viewerWidget.domNode.querySelectorAll('.foreign-object');
        for (let elem of foreign_element as any as Array<HTMLElement>) {
            let coreElements = elem.querySelectorAll(".e-pdfviewer-signatureformfields");
            for (let coreElem of coreElements as any as Array<HTMLElement>) {
                let id = coreElem.getAttribute("ID");
                ids[id] = id;
            }
        }
        for (let id in ids) {
            try{
                viewer.formDesigner.deleteFormField(id);
            }catch(e){
                //session storage string ist undefined und deshalb error bei json parse in syncfusion
                console.error("exception deleting form field",e);
            }
        }

        for (let key in this.yousignFields) {
            let field = this.yousignFields[key];
            if (typeof field.field['isReadOnly'] != 'boolean'){
                field.field['isReadOnly'] = false;
            }
            let i = Number(key);
            let fgColors = ['black', 'black', 'black', 'white'];
            let bgColors = ["var(--w3LightBlue)", "var(--w3Lime)", "var(--w3Amber)", "var(--w3Red)"];

            let fgColor:string;
            let bgColor:string;
            if (field.field.isReadOnly == false){
                fgColor = fgColors[i % fgColors.length];
                bgColor = bgColors[i % bgColors.length];
            }else{
                //read-only felder
                fgColor = "black";
                bgColor = "#607d8b";
            }
            let name = field.type === "signature" ? this.translate("pdfYousign__Prefix_SignField") : this.translate("pdfYousign__Prefix_MentionField") + "_" + i;
            let sigName = name;
            if (field.name) sigName = field.name;
            if (field.field.isReadOnly) sigName += " - " + this.translate("DigitalSignatureEditor_Label_Readonly");

            let fieldIndicatorTxt = this.translate("pdfYousign__ShortHand_Signature");
            if (field.type == "mention") fieldIndicatorTxt = "@";

            let htmlField: HTMLDivElement = viewer.formDesignerModule.addFormField('SignatureField', {
                name: sigName,
                tooltip: name, //TOOLTIP WIRD ALS ID MISSBRAUCHT, WEIL SYNCFUSION NICHT IMMER BEI JEDEM EVENT FIELD ID MITGIBT AAAAAAAAAAA
                bounds: {
                    X: field.field.x,
                    Y: field.field.y,
                    Width: field.field.width,
                    Height: field.field.height
                },
                signatureIndicatorSettings: {
                    backgroundColor: bgColor,
                    color: fgColor,
                    opacity: 0.85,
                    text: fieldIndicatorTxt
                },
                pageNumber: field.field.page,
                isReadOnly: field.field.isReadOnly
            });
            i++;
            if (typeof htmlField != 'undefined'){
                htmlField.style.backgroundColor = 'rgba(218, 234, 247, 0.65)';
                if (field.field.isReadOnly == true) {
                    htmlField.style.border = "#444442 3px dashed";
                }
                let idElement = htmlField.querySelector(".e-pdfviewer-signatureformfields");
                let id = idElement.getAttribute("ID"); //weil warum auch gleich die ID zurueckgeben...
                field["id"] = id;
                field["fallbackID"] = name;
            }
        }
        if (viewer.toolbar.formDesignerToolbarModule.isToolbarHidden) {
            viewer.formFieldsModule.pdfViewerBase.signatureModule.createSignaturePanel = lang.hitch(this, () => {
                console.info("createSignaturePanel was blocked by pdfYousign.ts");
                viewer.toolbarModule.formDesignerToolbarModule.showFormDesignerToolbar();
                this.debounceSave();
            });

            viewer.toolbarModule.formDesignerToolbarModule.resetFormDesignerToolbar();
            viewer.toolbarModule.formDesignerToolbarModule.showFormDesignerToolbar();


            viewer.formDesigner.createPropertiesWindow = lang.hitch(this, () => {
                console.info("createPropertiesWindow was blocked by pdfYousign.ts"); // wir ueberschreiben das doppelklick menue
                this.debounceSave();
            });
        }

        let htmlFormFields:Array<HTMLDivElement> = document.querySelectorAll('[class="foreign-object"][id^="form_field_"][id*="_content_html_element"]') as any as Array<HTMLDivElement>;
        if (htmlFormFields.length > Object.keys(this.yousignFields).length){
            //hotfix: wenn waerend resize drag das element geloescht wird, haben wir ein dubliziertes feld mit einer eigenen idElement
            for (let htmlElem of htmlFormFields){
                let idAtrib = htmlElem.getAttribute("ID");
                let match = idAtrib.match(/^form_field_([a-zA-Z0-9]+)_content_html_element$/);
                if (match){
                    let id = match[1];
                    let found = false;
                    for (let yf in this.yousignFields){
                        let yfield = this.yousignFields[yf]
                        if (yfield.id == id){
                            found = true;
                        }
                    }
                    if (found == false){
                        console.info("trying to remove dead form field:", id);
                        try{
                            viewer.formDesigner.deleteFormField(id); //macht tastaechlich nix glaub ich warscheinlich weil das formField tot im DOM rumliegt, wir machen es trozdem sicherheitshalber
                        }catch{
                            console.error("unable to remove dead form field");
                        }
                        let elems = this.domNode.querySelectorAll('.foreign-object[id="form_field_'+ id +'_content_html_element"]') as any as Array<HTMLDivElement>;
                        for (let elem of elems){
                            try{
                                elem.parentElement.removeChild(elem);
                            }catch{
                                console.error("unable to remove dead form field");
                            }
                        }
                        elems = this.domNode.querySelectorAll("rect#" + id + "_content") as any as Array<HTMLDivElement>;
                        for (let elem of elems){
                            try{
                                elem.parentElement.parentElement.removeChild(elem.parentElement);
                            }catch{
                                console.error("unable to remove dead form field (drag drop stuff)");
                            }
                        }
                    }
                }
            }
        }

        //QoL: wir schreiben im button txt wie viele felder noch gesetzt werden muessen
        let btn = this.getSetSignatureButton();
        let label = btn.querySelector(".e-tbar-btn-text");
        if (btn.querySelector('.YouSignBtnIsActive') == null){ //wenn gerare ein feld gesetzt wird, aendern wir den text nicht
            label.innerHTML = this.translate("PdfViewer__CustomButton_YouSign_Place")
                + " (" + this.usedFieldsCounter + "/"
                            + this.available_signers + ")";
        }

        this.flagBlockDeleteEvent = false;

    }

    private _onPdfViewer_FieldMove(args: pdfTypes.formField_event) {
        debugger;
        for (let key in this.yousignFields) {
            let field = this.yousignFields[key];
            if (field.field.isReadOnly != true) {
                if (field.fallbackID == args.field.tooltip) {
                    field.field.x = args.currentPosition.X - (args.currentPosition.Width / 2); //warum syncfusion x/y cords auf den mittelpunkt vom feld legt? SEHR GUTE FRAGE
                    field.field.y = args.currentPosition.Y - (args.currentPosition.Height / 2);
                    field.field.width = args.currentPosition.Width;
                    field.field.height = args.currentPosition.Height;
                    field.field.page = args.pageIndex + 1; //pdf pages starten immer mit 1 (laut pdf standard), der index nicht...
                }
            } else {
                if (field.fallbackID == args.field.tooltip) {
                    this.render_fields();
                    return;
                }
            }
        }
        this.debounceSave();
    }
    private _onPdfViewer_FieldResize(args: pdfTypes.formField_event) {
        for (let key in this.yousignFields) {
            let field = this.yousignFields[key];
            if (field.field.isReadOnly != true) {
                if (field.fallbackID == args.field.tooltip) {
                    field.field.x = args.currentPosition.X - (args.currentPosition.Width / 2);
                    field.field.y = args.currentPosition.Y - (args.currentPosition.Height / 2);
                    field.field.width = args.currentPosition.Width;
                    field.field.height = args.currentPosition.Height;
                    field.field.page = args.pageIndex + 1;
                }
            } else {
                if (field.fallbackID == args.field.tooltip) {
                    this.render_fields();
                    return;
                }
            }
        }
        this.debounceSave();
    }

    private formFields_boundCheck(blockReRender=false){
        let triggerReRender = false;
        for (let key in this.yousignFields){
            let field = this.yousignFields[key];
            //min/max bounds field check
            if (this.max_values_singfield.width.min > field.field.width) {
                field.field.width = this.max_values_singfield.width.min;
                this.showToast(this.translate("pdfYousign__fieldBound_Width_Min"), "");
                triggerReRender = true;
            }
            if (this.max_values_singfield.width.max < field.field.width) {
                field.field.width = this.max_values_singfield.width.max;
                this.showToast("pdfYousign__fieldBound_Width_Max", "");
                triggerReRender = true;
            }

            if (this.max_values_singfield.height.min > field.field.height) {
                field.field.height = this.max_values_singfield.height.min;
                this.showToast("pdfYousign__fieldBound_Height_Min", "");
                triggerReRender = true;
            }
            if (this.max_values_singfield.height.max < field.field.height) {
                field.field.height = this.max_values_singfield.height.max;
                this.showToast("pdfYousign__fieldBound_Height_Max", "");
                triggerReRender = true;
            }
        }
        if ((triggerReRender == true) && (blockReRender == false)){ //block render um evtl. infinite loop in render methode zu verhindern
            let viewerWidget = this.pdfEditor.getPdfViewerWidget();
            let viewer = viewerWidget.getSyncFusionPdfViewer();
            viewer.toolbarModule.formDesignerToolbarModule.showFormDesignerToolbar(false);
            this.render_fields();
            viewer.toolbarModule.formDesignerToolbarModule.showFormDesignerToolbar(); //crash by the way wenn man true passed...
        }
    }
    private _onPdfViewer_FieldRemoved(args: pdfTypes.formField_event) {
        if (this.flagBlockDeleteEvent == true) {
            return;
        }
        for (let key in this.yousignFields) {
            let field = this.yousignFields[key];
            if (field.field.isReadOnly != true){
                if (field.fallbackID == args.field.tooltip) {
                    if (!this.yousignFields[key].isReadonly) this.usedFieldsCounter--;
                    delete this.yousignFields[key];
                    break;
                }
            }
        }
        this.render_fields();
        if (this.yF_length() <= this.usedFieldsCounter) {
            this.pdfEditor.yousign_addSigBtn_disabled(false);
        }
        this.debounceSave();
    }

    public loadSignatureObject(signatureObjectId: string, showAsDlg: boolean, config?: { type: "mention" | "signature" , ids: Array<number>}) {
        this.pitID = signatureObjectId;
        this.RequestManager.callfunction(
            "Webtool_API_SignatureObject__fetchObj",
            { objID: signatureObjectId, config },
            lang.hitch(this, this._onCallback_fetchObj, showAsDlg),
            lang.hitch(this, (err) => {
                console.error(err.Message);
                this.showToast(err.Message, "fas fa-bug");
            })
        );
    }

    public show(pitID: string, showAsDlg: boolean, data: { signatureData: Array<{ displayName?: string, currentSignaturePlacement?: string, fieldID?: number, type?: "mention" | "signature", readonly?: boolean }>, fileID: string, maxSigners: number, availableSigners: number }) {
        this.pitID = pitID;
        this._onCallback_fetchObj(showAsDlg, data);
    }

    private _onCallback_fetchObj(showAsDlg: boolean, res: { signatureData: Array<{ displayName?: string, currentSignaturePlacement?: string, fieldID?: number, type?: "mention" | "signature", readonly?: boolean }>, fileID: string, maxSigners: number, availableSigners: number }) {

        this.available_signers = res.availableSigners;
        this.max_signers_per_object = res.maxSigners;
        this.showPdf({ key: res.fileID }, showAsDlg);
        this.yousignFields = [];
        for (let sigData of res.signatureData) {
            let name = ""; //"" wird mit platzhalter spaeter ersetzt
            if (typeof sigData.displayName == 'string') {
                if (sigData.displayName != "") {
                    name = sigData.displayName;
                }
            }

            if (!sigData.readonly) this.availableFields[this.availableFields_getFreeIndex()] = sigData;

            if (typeof sigData.currentSignaturePlacement == 'string') {
                if (sigData.currentSignaturePlacement != "") {
                    let ysf: { field: pdfTypes.yousignField, fieldID?: number, type?: "signature" | "mention", name?: string } = { field: JSON.parse(sigData.currentSignaturePlacement) };
                    ysf.fieldID = sigData.fieldID;
                    ysf.field.isReadOnly = sigData.readonly;
                    ysf.type = sigData.type;
                    ysf.name = sigData.displayName;

                    this.yousignFields[this.yF_getFreeIndex()] = ysf;
                    if (!sigData.readonly) this.usedFieldsCounter++;
                }
            }
        }

        this.dlg.disableAllButtons(true);
        this.pdfEditor.on("pageRenderCompleteFirstLoad", lang.hitch(this, ()=>{
            this.dlg.disableAllButtons(false);
            let v = this.pdfEditor.getPdfViewerWidget();
            let sfv = v.getSyncFusionPdfViewer();
            for (let key in this.yousignFields){
                // hier wird pdf coords von punkte (wie im pdf standard) auf pixel vom syncfusion reader convertiert
                let field = this.yousignFields[key];
                field.field.x = sfv.viewerBase.ConvertPointToPixel(field.field.x);
                field.field.y = sfv.viewerBase.ConvertPointToPixel(field.field.y);
                field.field.width = sfv.viewerBase.ConvertPointToPixel(field.field.width);
                field.field.height = sfv.viewerBase.ConvertPointToPixel(field.field.height);
            }
            this.render_fields();
            if (this.usedFieldsCounter >= this.available_signers) {
                v.yousign_addSigBtn_disabled(true);
            }
            let toolBarElement:HTMLDivElement = v.domNode.querySelector(".e-toolbar-right");
            this.saveIconContainer = document.createElement("span");
            toolBarElement.insertBefore(this.saveIconContainer, toolBarElement.firstChild);
            this.setSaveStatusIcon('saved');
            //jump to first sig page
            this.emit("firstRenderDone");
            return;
            //wegen syncfusion render-bug unused
            let minPageFound = -1;
            if (Object.keys(this.yousignFields).length > 0){
                for (let key in this.yousignFields){
                    let field = this.yousignFields[key];
                    let page = field.field.page;
                    if (minPageFound == -1){
                        minPageFound = page;
                    }else{
                        if (minPageFound > page){
                            minPageFound = page;
                        }
                    }
                }
                let vsf= v.getSyncFusionPdfViewer();
                vsf.navigationModule.goToPage(minPageFound);
            }
        }));
    }

    private setSaveStatusIcon(status:'saved'|'saving'|'error'){
        let isError = false;
        let innerHtml;
        switch (status){
            case "saved":
                innerHtml = '<div class="w3-badge w3-green w3-padding saveStatusBtn" title="' + this.translate("pdfYousign__SyncStatus_Success") + '"><i class="far fa-save"></i></div>';
                this.isDirty = false;
                break;
            case "saving":
                innerHtml = '<div class="w3-badge w3-orange w3-padding saveStatusBtn" title="' + this.translate("pdfYousign__SyncStatus_InProgress") + '"><i class="fas fa-sync w3-spin"></i></div>';
                this.isDirty = true;
                break;
            case "error":
                innerHtml = '<div class="w3-badge w3-red w3-padding saveStatusBtn" title="' + this.translate("pdfYousign__SyncStatus_Error") + '"><i class="fas fa-times"></i></div>';
                this.isDirty = true;
                isError = true;
                break;
            default:
                return this.setSaveStatusIcon('error');
                break;
        }
        this.emit("dirty", this.isDirty);
        this.saveIconContainer.innerHTML = innerHtml;
        if (this.flagDisableAutoSave == false){
            this.dlg.disableAllButtons(this.isDirty);
        }else{
            this.dlg.disableAllButtons(false);
        }
        if (isError) this.dlg.disableAllButtons(false); // bei einem fehler soll der user das dlg zumachen koennen...
    }
    private debounceSave() {
        clearTimeout(this.saveDebounce);
        this.setSaveStatusIcon('saving');
        this.saveDebounce = setTimeout(lang.hitch(this, this.save),
            this.saveDebounce_delay
        );
    }

    public save() {
        this.setSaveStatusIcon('saving');
        try{
            clearTimeout(this.saveDebounce);
        }catch{}
        //cords rounding just to be sure :)
        for (let key in this.yousignFields){
            let field = this.yousignFields[key];
            field.field.height = Math.round(field.field.height);
            field.field.width = Math.round(field.field.width);
            field.field.x = Math.round(field.field.x);
            field.field.y = Math.round(field.field.y);
            //page sparen wir uns :)
        }
        this.formFields_boundCheck(false);

        let pvw = this.pdfEditor.getPdfViewerWidget();
        let sfv = pvw.getSyncFusionPdfViewer();

        let res: Array<Object> = [];

        let keys: string[] = Object.keys(this.yousignFields);
        keys.sort((a: any, b: any) => { return Number(a) - Number(b); })
        for (let key of keys) {
            let ysf: pdfTypes.yousignField = JSON.parse(JSON.stringify(this.yousignFields[key].field)); // deepcopy
            //coords convertieren auf punkte vor abschicken zum server
            ysf.x = sfv.viewerBase.ConvertPixelToPoint(ysf.x);
            ysf.y = sfv.viewerBase.ConvertPixelToPoint(ysf.y);
            ysf.width = sfv.viewerBase.ConvertPixelToPoint(ysf.width);
            ysf.height = sfv.viewerBase.ConvertPixelToPoint(ysf.height);
            let tmp = { yousignField: this.JSON.stringify(ysf), fieldID: this.yousignFields[key].fieldID, type: this.yousignFields[key].type, isReadonly: ysf.isReadOnly };
            res.push(tmp);
        }

        let payload = { data: res, objID: this.pitID };
        console.info("requesting signature field position save:", payload);
        if (this.flagDisableAutoSave == false){
            this.RequestManager.callfunction(
                "Webtool_API_SignatureObject__saveObj",
                payload,
                lang.hitch(this, this._responseCallback_onSaved),
                lang.hitch(this, (err) => {
                    console.error(err.Message);
                    this.showToast(err.Message, "fas fa-bug");
                    this.setSaveStatusIcon('error');
                })
            );
        }
        this.lastSaved = payload;
    }

    private _responseCallback_onSaved(res:any){
        console.info("signature fields saved (" + this.pitID + ")", res);
        this.setSaveStatusIcon('saved');
        this.emit("saved", res);
    }

    private getSetSignatureButton():HTMLButtonElement{
        return this.domNode.querySelector('button[id="YouSignSignature"]');
    }

    public lastSaved:any;
    private flagDisableAutoSave: boolean = false;
    public setDisableAutoSave(isDisabled:boolean){
        if (isDisabled){
            this.domNode.classList.add("disableAutoSave");
            this.flagDisableAutoSave = true;
        }else{
            this.domNode.classList.remove("disableAutoSave");
            this.flagDisableAutoSave = false;
        }
        if (typeof this.dlg != 'undefined'){
            if (this.flagDisableAutoSave == false) {
                this.dlg.disableAllButtons(this.isDirty);
            } else {
                this.dlg.disableAllButtons(false);
            }
        }
    }
}

export default mdsWidget(pdfYousign);
